import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'iw-control-select',
  templateUrl: './control-select.component.html',
  styleUrls: ['./control-select.component.scss']
})
export class ControlSelectComponent implements OnInit {
  // datos a mostrar en el control
  public items: Array<any> = [
    { pais: 'Amsterdam', codigo: 1 }, { pais: 'Antwerp', codigo: 2 },
    { pais: 'Colorado', codigo: 3}, { pais: 'Maiami', codigo: 4 },
    { pais: 'España', codigo: 6 }, { pais: 'Florida', codigo: 5 },
    { pais: 'Puerto rico', codigo: 7 }, { pais: 'Francia', codigo: 8 },
    { pais: 'Suiza', codigo: 9 }, { pais: 'Italia', codigo: 10 },
    { pais: 'Colombia', codigo: 18 }, { pais: 'New york', codigo: 11 },
    { pais: 'Argentina', codigo: 17 }, { pais: 'Mexico', codigo: 12 },
    { pais: 'Paraguay', codigo: 16 }, { pais: 'Rusia', codigo: 13 },
    { pais: 'Rumania', codigo: 15 }, { pais: 'Alemania', codigo: 14 }
  ];

  constructor() { }

  ngOnInit() {
  }

  /**
   * Controla el evento cuando se selecciona una opcion
   *
   * @param {*} [data]
   * @memberof ControlSelectComponent
   */
  select(data?: any) {
    console.log(data);
  }

  /**
   * Controla el evento cuando se eliminan todos las opciones selecionadas en el control
   *
   * @memberof ControlSelectComponent
   */
  onClear() {
    alert('Items eliminados');
  }
}



// WEBPACK FOOTER //
// ./src/app/examples/control-select/control-select.component.ts